import React from "react";
import DownloadButtonsGroup from "./DownloadButtonsGroup";

const features = [
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10 2a8 8 0 100 16A8 8 0 0010 2zm0 3a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm0 10a5 5 0 01-4-2c.02-1.33 2.67-2 4-2s3.98.67 4 2a5 5 0 01-4 2z" fill="currentColor"/>
      </svg>
    ),
    title: 'Photo Scanning',
    desc: 'Snap a photo and it instantly identifies and logs the item. Ammo boxes, firearms, supplies — no manual entry required.',
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10 1l2.39 4.84L18 6.88l-4 3.9.94 5.5L10 13.77l-4.94 2.51.94-5.5-4-3.9 5.61-.04L10 1z" fill="currentColor"/>
      </svg>
    ),
    title: 'Private by Default',
    desc: 'Your data stays on your device. No cloud required, no account needed. Only you control your inventory.',
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <rect x="2" y="5" width="16" height="12" rx="2" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M6 5V4a4 4 0 018 0v1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        <circle cx="10" cy="11" r="2" fill="currentColor"/>
      </svg>
    ),
    title: 'Everything in One Place',
    desc: 'Ammo, firearms, reloading components, water, and medical supplies — one app for your entire preparedness inventory.',
  },
];

const UnlockPowerSection: React.FC<{ onLearnMoreClick?: () => void, onSignUpClick?: () => void }> = ({ onSignUpClick = () => {} }) => (
  <section className="w-full bg-[#000000] py-24 px-4">
    <div className="max-w-6xl mx-auto">

      {/* Header */}
      <div className="mb-16 text-center">
        <p className="text-xs font-bold uppercase tracking-widest text-[#3b82f6] mb-3">Get Started</p>
        <h2 className="text-4xl md:text-5xl font-extrabold text-white leading-tight mb-4">
          Know Exactly What You Have.<br className="hidden md:block" /> Always.
        </h2>
        <p className="text-[#a3a3a3] max-w-xl mx-auto text-lg leading-relaxed">
          Open the app. In seconds, see every caliber, every round count, your medical kit status, and what to restock before deer season. No guessing. No cloud. Just clarity.
        </p>
      </div>

      {/* Content: features left, image right */}
      <div className="flex flex-col lg:flex-row items-stretch gap-8">

        {/* Left: feature list + CTA */}
        <div className="flex-1 flex flex-col justify-between bg-[#1a1a1a] border border-white/10 rounded-2xl p-8 md:p-10">
          <div className="space-y-8 mb-10">
            {features.map((f) => (
              <div key={f.title} className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-[#3b82f6]/10 border border-[#3b82f6]/20 flex items-center justify-center text-[#3b82f6]">
                  {f.icon}
                </div>
                <div>
                  <div className="text-white font-semibold mb-1">{f.title}</div>
                  <div className="text-[#a3a3a3] text-sm leading-relaxed">{f.desc}</div>
                </div>
              </div>
            ))}
          </div>
          <p className="text-sm text-[#a3a3a3] italic mb-4">
            Every time you're not sure what you have, you're less prepared than you think.
          </p>
          <DownloadButtonsGroup variant="white" />
        </div>

        {/* Right: image */}
        <div className="flex-1 min-h-[320px] rounded-2xl overflow-hidden border border-white/10">
          <img
            src="/old_ammo.webp"
            alt="Old ammo boxes and cartridges"
            className="w-full h-full object-cover"
            width={1882}
            height={1206}
            draggable={false}
            loading="lazy"
          />
        </div>

      </div>
    </div>
  </section>
);

export default UnlockPowerSection;
